import { render, staticRenderFns } from "./mergeServers.vue?vue&type=template&id=44c4b662&scoped=true&"
import script from "./mergeServers.vue?vue&type=script&lang=js&"
export * from "./mergeServers.vue?vue&type=script&lang=js&"
import style0 from "./mergeServers.vue?vue&type=style&index=0&id=44c4b662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c4b662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c4b662')) {
      api.createRecord('44c4b662', component.options)
    } else {
      api.reload('44c4b662', component.options)
    }
    module.hot.accept("./mergeServers.vue?vue&type=template&id=44c4b662&scoped=true&", function () {
      api.rerender('44c4b662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/components/mergeServers.vue"
export default component.exports